import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SetMinDurationsModal from '../components/pages/reports/setMinDurationsModal/content';

function SetMinDurationsForReportPage(props) {
  const typingMinConDurationValue = useSelector((state) => state.reportReducer.typingMinConDurationValue);
  const typingMinMeetingDurationValue = useSelector((state) => state.reportReducer.typingMinMeetingDurationValue);
  const userId = useSelector((state) => state.usersReducer.userProfile.id);

  const dispatch = useDispatch();

  return (
    <SetMinDurationsModal
      startDate={props.startDate}
      endDate={props.endDate}
      typingMinConDurationValue={typingMinConDurationValue}
      typingMinMeetingDurationValue={typingMinMeetingDurationValue}
      userId={userId}
      dispatch={dispatch}
    />
  );
}

export default SetMinDurationsForReportPage;
